export const ERROR_CHECK_INTERNET =
  "Please check your internet connection or something";
export const ERROR_CANT_CREATE_MORE_DOMAIN =
  "You can have atmost 3 custom domains per account";
export const ERROR_DOMAIN_ENGAGED_OTHERWISE =
  "Someone else is already using this domain";
export const ERROR_CONDITIONAL_CHECK_FAILED = "ConditionalCheckFailedException";
export const ERROR_INVALID_DOMAIN = "Domnain name is invalid";
export const ERROR_EMPTY_DOMAIN = "Domnain name can't be empty";
